import { useState, useEffect } from "react";

export default function IntroAnimation() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Une seule fois par session
    const seen = sessionStorage.getItem("intro_seen");
    if (!seen) {
      setVisible(true);
      sessionStorage.setItem("intro_seen", "true");
      setTimeout(() => setVisible(false), 2400);
    }
  }, []);

  if (!visible) return null;

  return (
    <div style={{
      position: "fixed",
      inset: 0,
      zIndex: 99999,
      overflow: "hidden",
      background: "#f3f3f3",
      animation: "introFadeOut 0.35s ease 2.05s forwards",
    }}>
      <style>{`
        @keyframes introFadeOut {
          to { opacity: 0; pointer-events: none; }
        }

        @keyframes introBgDarken {
          0%,65% {
            background: radial-gradient(circle at center, #ffffff 0%, #efefef 60%, #dddddd 100%);
          }
          100% {
            background: radial-gradient(circle at right, #333 0%, #111 45%, #000 100%);
          }
        }

        @keyframes introTrailMove {
          0%   { transform: translateX(0vw);   opacity: 0;   filter: blur(3px); }
          15%  { opacity: .12; }
          55%  { opacity: .35; }
          100% { transform: translateX(220vw); opacity: .75; filter: blur(10px); }
        }

        @keyframes introWhiteMove {
          0%,58% { transform: translateX(0vw); opacity: 0; }
          100%   { transform: translateX(240vw); opacity: .9; }
        }

        @keyframes introAccelerate {
          0% {
            transform: translate(-45vw,-50%) scale(.72);
            filter: blur(0px) brightness(1);
            opacity: 1;
          }
          45% {
            transform: translate(0vw,-50%) scale(.82);
            filter: blur(.4px) brightness(1);
          }
          70% {
            transform: translate(35vw,-50%) scale(.92);
            filter: blur(1.2px) brightness(1.05);
          }
          100% {
            transform: translate(135vw,-50%) scale(1.12);
            filter: blur(4px) brightness(2.4)
              drop-shadow(0 0 20px white)
              drop-shadow(0 0 70px rgba(255,255,255,.9));
            opacity: 1;
          }
        }

        @keyframes introRedFlare {
          0%,72% { opacity: 0; }
          100%   { opacity: 1; }
        }

        @keyframes introFlash {
          0%,78%,100% { opacity: 0; }
          86%  { opacity: .18; }
          92%  { opacity: 0; }
        }

        .intro-scene {
          position: absolute;
          inset: 0;
          animation: introBgDarken 2.2s linear forwards;
        }

        .intro-trail {
          position: absolute;
          left: -120vw;
          height: 10px;
          background: linear-gradient(90deg, transparent, rgba(0,0,0,.28), rgba(0,0,0,.08), transparent);
          border-radius: 999px;
          filter: blur(5px);
          animation: introTrailMove 2.2s cubic-bezier(.7,0,1,1) forwards;
        }

        .intro-white {
          position: absolute;
          left: -100vw;
          height: 4px;
          width: 120vw;
          background: linear-gradient(90deg, transparent, rgba(255,255,255,.95), transparent);
          filter: blur(4px);
          opacity: 0;
          animation: introWhiteMove 2.2s cubic-bezier(.7,0,1,1) forwards;
        }

        .intro-logo {
          position: absolute;
          top: 50%;
          width: 520px;
          max-width: 80vw;
          transform: translateY(-50%);
          animation: introAccelerate 2.2s cubic-bezier(.7,0,1,1) forwards;
          z-index: 5;
        }

        .intro-red {
          position: absolute;
          right: -15vw;
          top: 50%;
          width: 55vw;
          height: 5px;
          transform: translateY(-50%);
          background: linear-gradient(90deg, transparent, rgba(255,0,0,.9), white);
          filter: blur(4px);
          opacity: 0;
          animation: introRedFlare 2.2s linear forwards;
          z-index: 7;
        }

        .intro-flash {
          position: absolute;
          inset: 0;
          background: white;
          opacity: 0;
          animation: introFlash 2.2s linear forwards;
          pointer-events: none;
          z-index: 20;
        }
      `}</style>

      <div className="intro-scene">
        {/* Trails */}
        <div className="intro-trail" style={{ top: "38%", width: "120vw", opacity: .18 }} />
        <div className="intro-trail" style={{ top: "45%", width: "140vw", opacity: .28, animationDelay: ".03s" }} />
        <div className="intro-trail" style={{ top: "52%", width: "170vw", opacity: .42, animationDelay: ".06s" }} />
        <div className="intro-trail" style={{ top: "59%", width: "130vw", opacity: .24, animationDelay: ".09s" }} />

        {/* White streaks */}
        <div className="intro-white" style={{ top: "42%" }} />
        <div className="intro-white" style={{ top: "49%", animationDelay: ".04s" }} />
        <div className="intro-white" style={{ top: "56%", animationDelay: ".08s" }} />

        {/* Logo */}
        <img
          className="intro-logo"
          src="/images/S5L_2.png"
          alt="Starting Five"
        />

        {/* Red flare + flash */}
        <div className="intro-red" />
        <div className="intro-flash" />
      </div>
    </div>
  );
}
